import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "./ui/card";
import { Toaster } from "./ui/sonner";
import { AdminLayout } from "./admin/AdminLayout";
import { AdminHomeHeroMediaManager } from "./admin/AdminHomeHeroMediaManager";

export default function AdminDashboardPage() {
  return (
    <AdminLayout description="Retrouvez ici une structure d’administration calquée sur le site visiteur, pour gérer progressivement les contenus publics, les médias et les règles métier." title="Accueil admin">
      <div className="grid gap-6 xl:grid-cols-3" data-testid="admin-dashboard-page">
        <Card className="rounded-[2rem] border border-[#d9e7d5]/90 bg-white/92 shadow-[0_24px_70px_-48px_rgba(15,118,110,0.2)] xl:col-span-2" data-testid="admin-dashboard-card">
          <CardContent className="p-10 sm:p-12">
            <div className="text-sm font-semibold uppercase tracking-[0.22em] text-[#0f766e]" data-testid="admin-dashboard-eyebrow">Vue d’ensemble</div>
            <h1 className="bim-display mt-4 text-4xl font-semibold tracking-tight text-slate-950" data-testid="admin-dashboard-title">Espace administrateur structuré</h1>
            <p className="mt-5 max-w-2xl text-lg leading-9 text-slate-600" data-testid="admin-dashboard-description">
              Vous pouvez maintenant naviguer dans une arborescence admin qui reflète le site visiteur. La page BIM 3D + Synthèse est la première rubrique entièrement administrable.
            </p>
            <div className="mt-8 flex flex-wrap gap-4 text-sm" data-testid="admin-dashboard-quicklinks">
              <Link className="rounded-full bg-[#0f766e] px-5 py-3 font-medium text-white hover:bg-[#149289]" data-testid="admin-dashboard-link-bim3d" to="/admin/bim-3d-synthese">Gérer BIM 3D + Synthèse</Link>
              <Link className="rounded-full border border-[#d8ece4] bg-white/90 px-5 py-3 font-medium text-[#0f766e] hover:bg-[#ecfdf5]" data-testid="admin-dashboard-link-site" to="/site">Voir le site visiteur</Link>
            </div>
          </CardContent>
        </Card>

        <Card className="rounded-[2rem] border border-[#d9e7d5]/90 bg-[linear-gradient(180deg,_rgba(255,255,255,0.92)_0%,_rgba(240,253,244,0.95)_100%)] shadow-[0_24px_70px_-48px_rgba(15,118,110,0.2)]" data-testid="admin-dashboard-status-card">
          <CardContent className="p-8">
            <div className="text-sm font-semibold uppercase tracking-[0.22em] text-[#0f766e]">Rubrique active</div>
            <div className="mt-4 text-2xl font-semibold text-slate-950">BIM 3D + Synthèse</div>
            <p className="mt-4 text-sm leading-7 text-slate-600">Gestion des médias Hero, ordre du carrousel, états actif/inactif et administration des règles de pricing BIM 3D.</p>
          </CardContent>
        </Card>
      </div>
      <AdminHomeHeroMediaManager />
      <Toaster closeButton position="top-center" />
    </AdminLayout>
  );
}